module.exports = __webpack_public_path__ + "assets/terms/termos-br.5d7eaf68.pdf";